var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.57735C11.6188 1.22008 12.3812 1.22008 13 1.57735L21.3923 6.42265C22.0111 6.77992 22.3923 7.44017 22.3923 8.1547V17.8453C22.3923 18.5598 22.0111 19.2201 21.3923 19.5774L13 24.4226C12.3812 24.7799 11.6188 24.7799 11 24.4226L2.6077 19.5774C1.98889 19.2201 1.6077 18.5598 1.6077 17.8453V8.1547C1.6077 7.44017 1.98889 6.77992 2.6077 6.42265L11 1.57735Z",
    stroke: "#0767FD",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3.25,
    stroke: "#0767FD",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.fd51cf710ac12009a6d11f5a0eb7745a.svg";
export { ForwardRef as ReactComponent };